import { useMemo } from 'react';

import useInventoryItemList from './useInventoryItemList';

const useExposedItems = () => {
  const { consumableItems, periodicItems, subscriptionItems } = useInventoryItemList();

  return useMemo(() => {
    const allItems = [...consumableItems, ...periodicItems, ...subscriptionItems];

    return allItems.length > 0
      ? allItems.map(({ itemId, useCount }) => ({ item_id: itemId, quota: useCount }))
      : 'none';
  }, [consumableItems, periodicItems, subscriptionItems]);
};

export default useExposedItems;
